<div class="theme-container privacy-policy">
  <div
    class="gap-24 public-header d-flex align-items-center header breadcrumb-main">
    <img alt="ST-logo" src="../assets/img/stolt-tankers-logo.svg" />
    <span class="color__primary">|</span>
    <h1 class="header-h1  fw-700 color__primary">{{ title }}</h1>
</div>
  <div class="full-width-body">
   <div class="container">
      <div class="status-container d-flex flex-column align-items-center gap-16">
        <!-- Status Icon (checkmark for success) -->
        <div class="status-icon" [ngClass]="{'approved': status === 'Approved', 'rejected': status === 'Rejected'}">
          <img *ngIf="status === 'Approved'" src="../assets/icon/check.svg" alt="check-mark" />
          <img *ngIf="status === 'Rejected'" src="../assets/icon/ban.svg" alt="rejected-mark" />
         
        </div>
        <!-- Optional Additional Details -->
        <div class="sub-heading-s1 color__secondary">{{message}}</div>
        
      </div>
    </div>
  </div>
</div>